import React from "react";
import { Breadcrumb, Row, Col, Space, Card } from "antd";
import { BrowserRouter as Router, NavLink } from "react-router-dom";
function ScrapData() {
  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Inventory</Breadcrumb.Item>
        <Breadcrumb.Item>Stock Transfer</Breadcrumb.Item>
      </Breadcrumb>
      <div
        className="site-layout-background"
        style={{ padding: 24, minHeight: 360 }}
      >
        <h2 className="titles">
          SCRAP <span>DATA</span>
        </h2>
        <p>Select type of transfer</p>
        <Row>
          <Col xs={12} xl={8}>
            <div className="LinksCard">
              <NavLink to="/endbit">
                <span className="icons icon-end-bit"></span>
                END-BIT DATA
              </NavLink>
            </div>
          </Col>
          <Col xs={12} xl={8}>
            <div className="LinksCard">
              <NavLink to="/rejections">
                <span className="icons icon-rejections"></span>
                REJECTIONS
              </NavLink>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default ScrapData;
